<template>
  <v-dialog v-model="dialog" style="max-width: 600px;">
    <template v-slot:activator="{ on }">
      <v-icon small v-on="on" @click="dialog = true" class="mr-2">mdi-eye</v-icon>
    </template>
    <v-card>
      <v-card-text>
        <PdfViewer v-if="dialog" :fileUrl="getFileUrl(documentId)" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.native="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ViewDocument',
  props: {
    expenseDocumentId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters('documents', ['getDocument', 'getFileUrl']),
    ...mapGetters('expenseDocuments', ['getExpenseDocument']),
    documentId() {
      return this.getExpenseDocument(this.expenseDocumentId)?.documentId;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
